import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Enhance Your Business Operations with TekRevol - A Leading Android
              App Development Company in Dubai
            </h2>
            <p>
              Our Android app development in Dubai is intended to help you grow
              and adapt to Dubai's continually changing environment. We develop
              mobile apps using advanced technologies and new solutions to
              provide a competitive advantage and improve client interaction in
              Dubai's market dynamics.
            </p>
            <p>
              Our professional team collaborates closely with you to understand
              your specific business requirements and objectives in Dubai. We
              then personalize our app development approach to provide solutions
              that scale and adapt to your Dubai business's growth.
            </p>
            <p>
              TekRevol is your partner in developing the digital tools you
              require to stay ahead and prosper in Dubai's competitive market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../images/location_new/fold11/ios-dubai.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
